module.exports = __webpack_public_path__ + "static/media/WhatsApp.93a88060.png";